import { State } from '@ngxs/store';
import { Injectable } from '@angular/core';

export class FormsStateModel {
  public addUserForm: {};
  public editUserForm: {};
}

@State<FormsStateModel>({
  name: 'forms',
  defaults: {
    addUserForm: {
      model: {},
      dirty: false,
      status: '',
      errors: {}
    },
    editUserForm: {
      model: {},
      dirty: false,
      status: '',
      errors: {}
    }
  }
})
@Injectable()
export class FormsState {
  constructor() { }
}
